import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Navbar from './components/nav-bar'

const ProtectedRoute = ({ isAuthenticated }) => {
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
    <Navbar/>
  <Outlet />
  </>
);
};

export default ProtectedRoute;